var _rect, _path, _rect2, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Laptop stand",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#EEF2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 78 L80 38 L124 78 Z",
    fill: "#002454"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 72,
    height: 6,
    rx: 2,
    fill: "#9e00ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 78 H112",
    stroke: "#002454",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 78,
    width: 16,
    height: 14,
    rx: 3,
    fill: "#9e00ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStand);
export default __webpack_public_path__ + "static/media/product-stand.757ac7d455a3e7129e1a274bda82cc7e.svg";
export { ForwardRef as ReactComponent };